export function getAllContainers(smartBay) {
    var _a;
    const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();
    const containers = [];
    for (const tierKey of allTiersKeys) {
        for (const stackKey of allStacksKeys) {
            const currContent = (_a = gridContent[stackKey]) === null || _a === void 0 ? void 0 : _a[tierKey];
            if (!currContent)
                continue;
            containers.push(...currContent.containers);
        }
    }
    return {
        containers,
        tBaysStr: smartBay.tBaysStr,
        level: smartBay.level,
    };
}
